export default "/images/card.svg?e5938bea6269326a5e4bf5883acb73ea";